// extracted by mini-css-extract-plugin
module.exports = {"head":"a630f0e637--head--BQjo4","title":"a630f0e637--title--hImtY","tab-content":"a630f0e637--tab-content--jJauo"};